import { DidomiContext } from 'app/app';
import AvatarWithBadge from 'app/common/mobile/avatar-with-badge/avatar-with-badge';
import ErrorModal from 'app/common/mobile/modals/error-modal/error-modal';
import ModalInfo from 'app/common/mobile/modals/modal-info/modal-info';
import ModalRating from 'app/common/mobile/modals/modal-rating/modal-rating';
import { FEED_BACK_ENTITY_TYPE } from 'app/config/constants';
import { DeviceType } from 'app/modules/cms/utils/cms-constants';
import { redirectToLounge } from 'app/modules/externalApp/service/lounge-service';
import { LoungeActionConstants } from 'app/modules/externalApp/utils/lounge-action-constant';
import { gtmEvent, refreshClientId } from 'app/modules/gtm/service/gtm.service';
import {
  computeStepEngineDatas,
  getNextStep,
  getPreviousStep,
  getSpecificStep,
  getSpecificStepFromEvent,
  hideNextButton,
  hidePreviousButton,
  resetStepEngine
} from 'app/modules/step-engine/service/step-engine-service';
import { ModalConstants, PagePart, Step, StepEngineBehaviorsConstants, StepEngineStepGroup } from 'app/modules/step-engine/utils/step-engine-constants';
import { viewsMapping } from 'app/modules/step-engine/utils/step-engine-mappers';
import { componentLoader, getKeyByValue } from 'app/modules/step-engine/utils/step-engine-methods';
import StepActions from 'app/shared/components/desktop/step-action/claim-declare-step-actions';
import StepActionsVertical from 'app/shared/components/desktop/step-action/step-action-vertical';
import StickyRecap from 'app/shared/components/desktop/sticky-recap/sticky-recap';
import { STEP_PREFIX } from 'app/shared/constants/constants';
import ErrorBoundary from 'app/shared/error/error-boundary';
import { FeedBackDTO } from 'app/shared/model/FeedBackDTO.model';
import { IRootState } from 'app/shared/reducers';
import { findSubscriptionByNumber, getSubscriberSherpa } from 'app/shared/reducers/kubrick-management';
import { isEmptyArray, isEmptyObject } from 'app/shared/util/method-util';
import { format } from 'date-fns';
import React, { useContext, useEffect, useState } from 'react';
import { translate } from 'react-jhipster';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { SpbProgressBar } from 'spb-react-components';
import { createFeedBack } from '../../service/client-service';
import {
  addGlobalData,
  removeDeclarationGlobalData,
  removeDisabledNextButton,
  removeGlobalData,
  setCurrentStep,
  setCurrentStepGroup,
  setLastEditStep,
  setShowEligibilityModal,
  setShowErrorModal,
  setShowRatingModal,
  setStepEngineDeviceType,
  setStepGroup,
  setStepListComponent
} from '../../service/store/step-engine-dispatchs';
import './claim-declare-steps-engine.scss';
import MobileSkeleton from './mobileSkeleton';
import SkeletonSteps from './skeleton-steps';
import { removeBehaviors } from 'app/modules/cms/service/store/cms-dispatchs';
import { getClaimProductCode } from 'app/modules/claim/service/claim-service';


export const ClaimDeclareStepsEngine = (props) => {
  const direction = useHistory();
  const urlParams = useParams();
  const dispatch = useDispatch();

  const didomi = useContext(DidomiContext);
  const { verticalDisplay, websiteCode } = useSelector((state: IRootState) => state.appManagement?.frontConfig);
  const { cmsContent, isLoading, isMobile } = useSelector((state: IRootState) => state.cms);

  const {
    previousSteps,
    stepData,
    globalData,
    backToHome,
    goToLoginError,
    disabledNextButton,
    declarationGlobalData,
    showEligibilityModal,
    showErrorModal,
    showRatingModal,
  } = useSelector((state: IRootState) => state.stepEngine);
  const {
    currentSteps,
    journeyData,
    showStepAction,
    lastEditStep,
    currentStepGroup,
    stepListComponent
  } = stepData || {};

  const { subscriptionNumber, subscriptionDate, productCode } = useSelector((state: IRootState) => state.kubrickManagement.subscription || {});
  const clientNumberFromStore = useSelector((state: IRootState) => state.kubrickManagement.subscriber?.number);
  const modalCancelBtnAttribute = useSelector((state: IRootState) => state.kubrickManagement.modalCancelBtn);
  const modalMsgAttribute = useSelector((state: IRootState) => state.kubrickManagement.modalMsg);
  const { prismic: popinPrismic } = cmsContent[PagePart.POP_IN] || {};
  const { ratingTitle, ratingText, ratingValidButton } = popinPrismic || {}
  const cancelButton = popinPrismic?.[modalCancelBtnAttribute] || {};
  const modalMsgDescription = popinPrismic?.[modalMsgAttribute] || {};
  const { claimNumber } = useSelector((state: IRootState) => state.claim);

  const [lastEditStepWithCustomerEntry, setlastEditStepWithCustomerEntry] = useState("");
  const [currentProgressBar, setCurrentProgressBar] = useState([]);
  const [componentItems, setComponentItems] = useState([]);
  const [showComponents, setShowComponents] = useState(false);
  const [stepListGroup, setStepListGroup] = useState([]);
  const [currentShowStepAction, setCurrentShowStepAction] = useState<any>();

  const { prismic, behaviors } = cmsContent[Step[currentSteps[0]]] || {};
  const { title, information } = prismic || {};
  const {
    prismic: errorModalPrismic,
  } = cmsContent[ModalConstants[behaviors?.[StepEngineBehaviorsConstants.SHOW_MODAL]]] || {};
  const {
    text,
    contactUsLink,
    contactUsMethod,
    contactUsButton,
    closeButton
  } = errorModalPrismic || {}
  const isInVerticalDisplay = verticalDisplay && !isMobile;
  const views = new Map();
  const queryString = props?.location.search;
  const query = new URLSearchParams(queryString);
  const stepNameQuery = query.get('stepName');
  const claimNumberQuery = query.get('claimNumber');

  const {
    behaviors: lastEditStepBehaviors
  } = cmsContent[lastEditStep] || {}

  const isLastStepInGroup = (
    lastEditStepBehaviors?.progressBar
    &&
    (lastEditStepBehaviors?.progressBar[1] - lastEditStepBehaviors?.progressBar[0] === 1)
  ) || behaviors?.stepGroup === StepEngineStepGroup.SINGLE

  const getNextView = () => {
    if (isInVerticalDisplay) {
      dispatch(setLastEditStep(Step[currentSteps[0]]))
    }
    dispatch(getNextStep());
  };

  const startWithSpecificStep = () => {
    if (urlParams['subscriptionNumber'] && claimNumberQuery && stepNameQuery) {
      return true;
    } else {
      return false;
    }
  }
  // ajouter le step dans une liste de step

  useEffect(() => {
    const items = [];
    // dispatch(setCurrentStepGroup(behaviors?.stepGroup))
    if (componentItems[0] && isInVerticalDisplay && behaviors?.stepGroup && Step[currentSteps[0]] === componentItems[0]?.props?.dataKey) {
      items.push(Object.assign({ stepReset: true, showStepAction }, componentItems[0]))
      const indexGroup = stepListGroup.indexOf(currentStepGroup)
      const checkDuplicatesCurrent = stepListComponent[stepListGroup[indexGroup]] ? stepListComponent[stepListGroup[indexGroup]]?.filter((listData: any) => items[0]?.props?.dataKey === listData?.props?.dataKey) : []
      if ((behaviors?.stepGroup !== StepEngineStepGroup.SINGLE && (checkDuplicatesCurrent?.length === 0))
        || (behaviors?.stepGroup === StepEngineStepGroup.SINGLE)) {
        const dataListComponent = stepListComponent[behaviors?.stepGroup]?.length > 0 ? [...stepListComponent[behaviors?.stepGroup], ...items] : [...items]
        dispatch(setStepListComponent({ ...stepListComponent, [behaviors?.stepGroup]: dataListComponent }));
        dispatch(setCurrentStepGroup(behaviors?.stepGroup))
        if (!stepListGroup.includes(behaviors?.stepGroup)) {
          setStepListGroup([...stepListGroup, behaviors?.stepGroup])
        }
      }
    }
  }, [componentItems, behaviors?.stepGroup]);

  useEffect(() => {
    setCurrentShowStepAction(behaviors?.showStepAction)
  }, [behaviors?.showStepAction])

  const setData = (stepId, dataValue) => {
    dispatch(computeStepEngineDatas(stepId, dataValue));
    dispatch(addGlobalData(stepId, dataValue));
    if (stepId !== Step.DECLARATION_SUMMARY) {
      dispatch(setLastEditStep(stepId));
    }
  };

  const disabledNext = () => {
    const enableNextButton = behaviors?.[StepEngineBehaviorsConstants.ENABLE_NEXT_BUTTON] ?? false;
    if (enableNextButton) return !enableNextButton;

    let hasNullValue = false;
    const checkNameStep = Object.keys(disabledNextButton).includes(currentSteps[0])
    if (checkNameStep) {
      for (const step of Object.keys(disabledNextButton)) {
        if (disabledNextButton[step]) {
          return true;
        }
      };
    } else {
      currentSteps.forEach(currentStep => {
        const value = declarationGlobalData[Step[currentStep]];
        if (typeof value === 'undefined' || value?.length === 0) {
          hasNullValue = true;
        }
      });
    }

    return hasNullValue;
  };

  const refreshStepListComponent = () => {
    // Supprime les questions après lastEditStep dans StepListComponent
    let item: any;
    const resetList = [];
    for (item of Object.values(stepListComponent[currentStepGroup] ?? [])) {
      resetList.push(item)
      if (item?.props?.dataKey === lastEditStep) {
        dispatch(setStepListComponent({ ...stepListComponent, [currentStepGroup]: [...resetList] }));
        break;
      }
    }
  }

  const refreshGlobalData = () => {
    // La liste des previousSteps est ordonnée, donc une fois l'écran ciblé trouvé dans la liste,
    // on supprime toutes les données des écrans suivants
    let findSpecificView = false;
    Object.keys(previousSteps).forEach(previousStep => {
      if (findSpecificView) {
        previousStep?.split(",").forEach(component => {
          dispatch(removeDeclarationGlobalData(Step[component]))
          dispatch(computeStepEngineDatas(Step[component], null, true));
          dispatch(removeDisabledNextButton(component));
        })
      }
      if (previousStep === getKeyByValue(Step, lastEditStep)) {
        findSpecificView = true
      }
    });
  }

  useEffect(() => {
    setlastEditStepWithCustomerEntry(lastEditStep);
    if (isInVerticalDisplay
      && getKeyByValue(Step, lastEditStep) !== currentSteps[0]
      && currentStepGroup === 'COVERAGE'
      && lastEditStep
    ) {
      const multipleCustomerEntries = cmsContent[lastEditStep].behaviors.multipleCustomerEntries;
      refreshStepListComponent();
      refreshGlobalData();
      dispatch(setCurrentStep([getKeyByValue(Step, lastEditStep)]))
      if (lastEditStepBehaviors?.forceNextStepOnSelection
        || !(globalData[lastEditStep] instanceof Array || typeof globalData[lastEditStep] === 'string')
        && !multipleCustomerEntries
      ) {
        dispatch(getNextStep());
      }
    }
    // }
  }, [journeyData.customerEntry])

  useEffect(() => {
    if (lastEditStepBehaviors?.resetCover) {
      dispatch(computeStepEngineDatas(Step.COVER_SELECTION, undefined, true));
    }
    if (isInVerticalDisplay
      && lastEditStep
      && !(typeof globalData[lastEditStep] === 'string')
      && (!lastEditStepBehaviors?.progressBar
        || (lastEditStepBehaviors?.progressBar
          && (lastEditStepBehaviors?.progressBar[1] - lastEditStepBehaviors?.progressBar[0] !== 1)
        )
      )
      && lastEditStep !== Step.GET_FIRST_STEP
      && lastEditStep !== lastEditStepWithCustomerEntry
    ) {
      refreshStepListComponent();
      refreshGlobalData();
      dispatch(setCurrentStep([getKeyByValue(Step, lastEditStep)]))
      if (lastEditStepBehaviors?.isNotRedirect !== true
        && (lastEditStepBehaviors?.forceNextStepOnSelection
          || !(globalData[lastEditStep] instanceof Array))
      ) {
        dispatch(getNextStep());
      }
    }
  }, [lastEditStep])

  // Animation du fil d'ariane
  useEffect(() => {
    if (!isMobile && behaviors?.progressBar) {
      setTimeout(() => {
        setCurrentProgressBar(behaviors?.progressBar)
      }, 1)
    }
  }, [behaviors?.progressBar, currentSteps]);

  // REDIRECTION LOUNGE : INVALIDE_SUBSCRIPTION
  const abandonDeclaration = () => {
    dispatch(gtmEvent("Non éligible", "Fermer", '0'))
    dispatch(redirectToLounge(LoungeActionConstants.NONE));
    dispatch(setShowEligibilityModal(false));
  };

  useEffect(() => {
    if (backToHome) {
      dispatch(redirectToLounge(LoungeActionConstants.NONE));
    }
  }, [backToHome]);

  useEffect(() => {
    if (goToLoginError) {
      direction.push('/login-error');
    }
  }, [goToLoginError]);

  useEffect(() => {
    if (subscriptionNumber) {
      dispatch(addGlobalData('subscriptionNumber', subscriptionNumber));
      const subscriptionDateObject = new Date(subscriptionDate);
      dispatch(addGlobalData('subscriptionDate', format(subscriptionDateObject, "yyyy-MM-dd'T'HH:mm:ss")));

      if (startWithSpecificStep()) {
        dispatch(getSpecificStepFromEvent({ stepName: stepNameQuery, claimNumber: claimNumberQuery }));
      } else {
        getNextView();
      }
    }
  }, [subscriptionNumber]);

  useEffect(() => {
    if (clientNumberFromStore) {
      dispatch(addGlobalData('clientNumber', clientNumberFromStore));
    }
  }, [clientNumberFromStore]);

  useEffect(() => {
    if (subscriptionNumber && didomi) {
      dispatch(gtmEvent('Initialisation session', 'Validé', '0'))
    }
  }, [subscriptionNumber, didomi]);

  useEffect(() => {
    if (isMobile !== null) {
      dispatch(resetStepEngine());
      dispatch(setStepEngineDeviceType(isMobile ? DeviceType.MOBILE : DeviceType.DESKTOP));
      // const session = sessionStorage.getItem('subscription');
      // if (!session && !urlParams['subscriptionNumber']) {
      if (!urlParams['subscriptionNumber']) {
        direction.push('/login-error');
      } else {
        if (urlParams['subscriptionNumber']) {
          history.pushState(null, null, location.href);
          window.onpopstate = function (event) {
            history.go(1);
          };
          // if (session && session !== urlParams['subscriptionNumber']) {
          refreshClientId();
          // }
          dispatch(findSubscriptionByNumber(urlParams['subscriptionNumber']));
        }
      }
    }
    return () => {
      dispatch(resetStepEngine());
    };

  }, [isMobile]);


  useEffect(() => {
    setShowComponents(
      !isEmptyArray(componentItems)
      &&
      !isEmptyObject(prismic)
      &&
      (!behaviors?.[StepEngineBehaviorsConstants.SHOW_MODAL] || !isEmptyObject(errorModalPrismic))
    );
  }, [componentItems, cmsContent]);

  const setErrorModal = (value: boolean) => {
    dispatch(setShowErrorModal(value));
  };

  const getPreviousView = () => {
    let listNotDuplicated: any = [];
    if (isInVerticalDisplay) {
      const indexGroup = stepListGroup.indexOf(currentStepGroup);
      listNotDuplicated = stepListComponent[stepListGroup[indexGroup - 1]]?.filter((item: any) => {
        return componentItems[0]?.props?.dataKey !== item?.props?.dataKey
      })
      dispatch(setCurrentStepGroup(stepListGroup[indexGroup - 1]));
      dispatch(setStepListComponent({ ...stepListComponent, [stepListGroup[indexGroup - 1]]: listNotDuplicated }));
      dispatch(setStepGroup(currentStepGroup));

      dispatch(removeDisabledNextButton(getKeyByValue(Step, Step[currentSteps[0]])));
      dispatch(removeGlobalData(Step[currentSteps[0]]));
      dispatch(removeDeclarationGlobalData(Step[currentSteps[0]]));
      dispatch(removeBehaviors(Step[currentSteps[0]]));

    }
    dispatch(getPreviousStep());
  };

  const getSpecificView = specificStep => {
    dispatch(getSpecificStep(specificStep));
  };

  const closeModal = () => {
    dispatch(setShowEligibilityModal(false));
  }
  const ratingData = (data) => {
    const feedBackDTO: FeedBackDTO = {
      comments: data?.comment,
      entity: {
        type: FEED_BACK_ENTITY_TYPE.CLAIM,
        value: claimNumber
      },
      rating: data?.rating,
      webSiteCode: websiteCode,
      accountId: null
    }
    dispatch(createFeedBack(feedBackDTO));
    dispatch(setShowRatingModal(false));
  };
  const closeModalRating = () => {
    dispatch(setShowRatingModal(false));
  }


  const initializeViews = () => {
    viewsMapping.forEach((value: string, key: Step) => {
      const Component = componentLoader(value);
      views.set(
        key,
        <Component
          dataKey={key}
          getNextStep={getNextView}
          getSpecificStep={getSpecificView}
          setGlobalData={setData}
          getPreviousStep={getPreviousView}
        />
      );
    });
  };

  const checkRedirectToHome = () => {
    if (Step[behaviors?.[StepEngineBehaviorsConstants.MODAL_HANDLE_BACK_TO_HOME]] === Step.GET_FIRST_STEP) {
      dispatch(resetStepEngine())
      getNextView();
    }
    if (StepEngineBehaviorsConstants[behaviors?.[StepEngineBehaviorsConstants.MODAL_HANDLE_BACK_TO_HOME]] === StepEngineBehaviorsConstants.REDIRECT_TO_LOUNGE) {
      dispatch(redirectToLounge(LoungeActionConstants.NONE));
    }
    if (behaviors?.[StepEngineBehaviorsConstants.MODAL_REDIRECT_TO_LOUNGE]) {
      dispatch(redirectToLounge(behaviors?.[StepEngineBehaviorsConstants.MODAL_REDIRECT_TO_LOUNGE]));
    }
  }

  const handleModalErrorClose = () => {
    if (behaviors?.[StepEngineBehaviorsConstants.HANDLE_PREVIOUS_STEP_ON_MODAL_CLOSE]) {
      getPreviousView();
    }
    if (Step[behaviors?.[StepEngineBehaviorsConstants.HANDLE_BACK_TO_HOME_ON_MODAL_CLOSE]] === Step.GET_FIRST_STEP) {
      dispatch(resetStepEngine())
      getNextView();
    }
    if (StepEngineBehaviorsConstants[behaviors?.[StepEngineBehaviorsConstants.HANDLE_BACK_TO_HOME_ON_MODAL_CLOSE]] === StepEngineBehaviorsConstants.REDIRECT_TO_LOUNGE) {
      dispatch(redirectToLounge(LoungeActionConstants.NONE));
    }
  }

  const handleContactUs = () => {
    if (behaviors?.[StepEngineBehaviorsConstants.HANDLE_CONTACT_US_LOUNGE]) {
      dispatch(redirectToLounge(LoungeActionConstants.CONTACT_FORM));
    }
  }

  useEffect(() => {
    initializeViews();
    if (currentSteps.length) {
      const items = [];
      currentSteps.map(item => {
        const componentItem = views.get(Step[item]);
        items.push(componentItem);
      });
      setComponentItems(items);
      if (isInVerticalDisplay) {
        const checkDuplicates = stepListComponent[currentStepGroup]?.filter((listData: any) => {
          items[0]?.props?.dataKey === listData?.props?.dataKey
        });
        if ((checkDuplicates?.length > 0)) {
          const indexGroup = stepListGroup.indexOf(currentStepGroup)
          const listNotDuplicated = stepListComponent[stepListGroup[indexGroup + 1]]?.filter((listData: any) => {
            componentItems[0]?.props?.dataKey !== listData?.props?.dataKey
          });
          dispatch(setStepListComponent({ ...stepListComponent, [stepListGroup[indexGroup + 1]]: listNotDuplicated }));
        }
      }
    }
  }, [currentSteps]);

    useEffect(() => {
    if (subscriptionNumber) {
      dispatch(getClaimProductCode(subscriptionNumber));

    }
    if (subscriptionNumber && productCode) {
      dispatch(getSubscriberSherpa(productCode, subscriptionNumber));
    }
  }, [subscriptionNumber]);


  const hideAvatarWithBadge = () => {
    return (behaviors?.hideAvatarWithBadge);
  }

  const hideBackButton = () => {
    return hidePreviousButton(cmsContent, currentSteps[0]);
  };

  const hideForwardButton = () => {
    return hideNextButton(cmsContent, currentSteps[0]);
  };


  const stepActionButton = () => {
    if (currentShowStepAction || !isInVerticalDisplay) {
      return (
        prismic && (
          <StepActions
            hidePreviousButton={hideBackButton}
            hideNextButton={hideForwardButton}
            getPreviousView={getPreviousView}
            getNextView={getNextView}
            disabledNext={disabledNext()}
            previousLabel={prismic?.previousButton}
            nextLabel={prismic?.nextButton}
          />
        ))
    } else if (currentShowStepAction === undefined && isInVerticalDisplay) {
      const isNotRedirect = behaviors?.isNotRedirect ?? false
      if (isNotRedirect === true) {
        return (
          <StepActionsVertical
            getNextView={getNextView}
            disabledNext={disabledNext()}
          />
        );
      }
    } else {
      return
    }
  }

  const getViews = () => {
    if (isInVerticalDisplay) {
      if (currentStepGroup && currentStepGroup === "SINGLE")
        return stepListComponent[currentStepGroup].slice(-1);
      else
        return currentStepGroup ? Object.values(stepListComponent[currentStepGroup]) : []
    }
    else
      return componentItems
  }

  return (
    <ErrorBoundary>
      {!isMobile && (isLoading || !showComponents) && isLastStepInGroup ?
        <SkeletonSteps />
        :
        <>
          {showComponents &&
            <>
              {isMobile ? isLoading ?
                <MobileSkeleton steps={currentSteps} />
                :
                <>
                  {!hideAvatarWithBadge() &&
                    <AvatarWithBadge
                      hideButton={hideBackButton()}
                      getPreviousStep={getPreviousView}
                      title={title}
                      text={!behaviors?.isUnique ? information : []}
                    />
                  }
                  {componentItems[0]}
                </>
                :
                <>
                  {(isInVerticalDisplay && !behaviors?.hideStickyRecap && behaviors?.stepGroup !== StepEngineStepGroup.SINGLE) &&
                    <StickyRecap questions={getViews()}></StickyRecap>
                  }
                  <div className="claim-declaration" style={(isInVerticalDisplay && currentSteps[0] === "DECLARATION_SUMMARY") ? { width: '80%' } : {}} >
                    {!isInVerticalDisplay &&
                      <SpbProgressBar color="#0092d4" currentProgressBar={currentProgressBar[0]} maxProgressBar={currentProgressBar[1]} />
                    }
                    <div className="steps-container">
                      {(!isInVerticalDisplay || (currentStepGroup && stepListComponent[currentStepGroup])) &&
                        getViews().map((componentItem: any, key) => {
                          const { dataKey } = componentItem?.props;
                          return (
                            <React.Fragment key={key}>
                              <div className="step-container" id={STEP_PREFIX + dataKey}>
                                {!hideAvatarWithBadge() &&
                                  <AvatarWithBadge
                                    hideButton={true}
                                    getPreviousStep={getPreviousView}
                                    title={cmsContent[dataKey]?.prismic?.title}
                                    text={cmsContent[dataKey]?.prismic?.information}
                                  />
                                }
                                {componentItem}
                              </div>
                            </React.Fragment>
                          );
                        })}
                      {prismic && stepActionButton()}
                      {isInVerticalDisplay && (isLoading || !showComponents) &&
                        (!lastEditStepBehaviors?.progressBar || (lastEditStepBehaviors?.progressBar && (lastEditStepBehaviors?.progressBar[1] - lastEditStepBehaviors?.progressBar[0] !== 1)))
                        &&
                        <SkeletonSteps />
                      }
                    </div>
                  </div>
                  {isInVerticalDisplay && (isLoading || !showComponents) &&
                    (!lastEditStepBehaviors?.progressBar || (lastEditStepBehaviors?.progressBar && (lastEditStepBehaviors?.progressBar[1] - lastEditStepBehaviors?.progressBar[0] !== 1)))
                    &&
                    <div className='page-blocker'></div>
                  }
                </>
              }
              {!isEmptyObject(errorModalPrismic) && (
                <ErrorModal
                  message={text}
                  link={contactUsLink}
                  method={contactUsMethod}
                  txtLink={contactUsButton}
                  txtButton={closeButton}
                  checkRedirectToHome={checkRedirectToHome}
                  modal={showErrorModal}
                  setModal={setErrorModal}
                  handleModalClose={handleModalErrorClose}
                  handleContactUs={handleContactUs}
                />
              )}
              <ModalInfo
                modal={showEligibilityModal}
                setModal={closeModal}
                handleOk={abandonDeclaration}
                message={[modalMsgDescription, translate("settings.redirect.lounge")]}
                txtValidButton={cancelButton}
              />
              <ModalRating
                modal={showRatingModal}
                title={ratingTitle}
                message={ratingText}
                txtValidButton={ratingValidButton}
                handleOk={ratingData}
                handleCancel={closeModalRating} />
            </>
          }
        </>
      }
    </ErrorBoundary >
  );
};

export default ClaimDeclareStepsEngine;
